<template>
  <div v-if="!hasSlotContent" :class="['grid', 'grid--four', cssClasses]">
    <template v-for="category of categories">
      <div
        :key="category.id"
        v-accordion-level-list="{ closeOthers: false, mediaQuery: true, expandFirst: false }"
        class="accordion-level-list category-page-categories js-accordion-level-list">
        <a ref="mainCategory" :href="category.url" class="navigational-item navigational-item--arrow navigational-item--dark-blue">
          {{ category.name }}
        </a>

        <a
          v-for="subCategory of category.subCategories.slice(0, slice)"
          :key="subCategory.id"
          :href="subCategory.url"
          class="navigational-item navigational-item--arrow navigational-item--light-blue accordion-level-list__sub-item">{{ subCategory.name }}
        </a>

        <div
          v-if="category.subCategories.length >= slice"
          :id="`${category.id}-content`"
          :aria-labelledby="`${category.id}-toggler`"
          aria-hidden="true"
          class="accordion-level-list__hidden-sub-items">
          <a
            v-for="subCategory of category.subCategories.slice(slice)"
            :key="subCategory.id"
            :href="subCategory.url"
            class="navigational-item navigational-item--arrow navigational-item--light-blue accordion-level-list__sub-item">{{ subCategory.name }}
          </a>
        </div>

        <button
          v-if="category.subCategories.length > slice"
          :id="`${category.id}-toggler`"
          :aria-controls="`${category.id}-content`"
          aria-expanded="false"
          class="accordion-level-list__toggle js-accordion-toggler">
          <div class="accordion-level-list__toggle-inner accordion-level-list__toggle-reveal">
            <oie-use-svg svg="expand-circle"></oie-use-svg>
            {{ tStatic('showMoreLink') }}
          </div>

          <div class="accordion-level-list__toggle-inner accordion-level-list__toggle-desmiss">
            <oie-use-svg svg="desmiss-circle"></oie-use-svg>
            {{ tStatic('closeLink') }}
          </div>
        </button>
      </div>
    </template>

    <div v-for="i of 4" :key="`category-top-list-${i}`" class="grid__item--filler"></div>
  </div>

  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    categoryId: {
      type: String,
      default: null
    },
    modelId: {
      type: String,
      default: null
    },
    categoryItems: {
      type: Array,
      default: () => []
    },
    breadcrumbDepth: {
      type: [String, Number],
      default: '0'
    }
  },
  data: () => ({
    categories: null,
    slice: 5
  }),
  computed: {
    hasSlotContent() {
      return this.$slots.default !== undefined
    }
  },
  mounted() {
    if (this.categoryId) {
      httpService.get(`category/${this.categoryId}/subcategories/${this.modelId || ''}?depth=${this.breadcrumbDepth}`).then(({ data }) => {
        this.categories = data

        this.$nextTick(function() {
          this.equalHeight()
        })
      })
    } else {
      this.categories = this.categoryItems

      this.$nextTick(function() {
        this.equalHeight()
      })
    }
  },
  methods: {
    equalHeight() {
      let height = 0

      if (!this.$refs.mainCategory) { return }

      this.$refs.mainCategory.forEach(element => {
        const elementHeight = element.getBoundingClientRect().height

        if (elementHeight > height) {
          height = elementHeight
        }
      })

      this.$refs.mainCategory.forEach(element => {
        element.style.height = `${height / 16}rem`
      })
    }
  }
}
</script>
